var _desc, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBike(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 640,
    height: 480,
    viewBox: "0 0 640 480",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Fabric.js 3.6.6")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(-1 0 0 1 128 128)"
  }, /*#__PURE__*/React.createElement("g", {
    style: {}
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 0 0)",
    id: "bicycle"
  }, /*#__PURE__*/React.createElement("rect", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "none",
      fillRule: "nonzero",
      opacity: 1
    },
    x: -128,
    y: -128,
    rx: 0,
    ry: 0,
    width: 256,
    height: 256
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 52 -16)",
    id: "bicycle"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "rgb(234,111,28)",
      strokeWidth: 8,
      strokeDasharray: "none",
      strokeLinecap: "round",
      strokeDashoffset: 0,
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      fill: "none",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " translate(-180, -112)",
    d: "M 208 80 a 16 16 0 0 0 -16 -16 H 152 l 56 96",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 80 32)",
    id: "bicycle"
  }, /*#__PURE__*/React.createElement("circle", {
    style: {
      stroke: "rgb(234,111,28)",
      strokeWidth: 8,
      strokeDasharray: "none",
      strokeLinecap: "round",
      strokeDashoffset: 0,
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      fill: "none",
      fillRule: "nonzero",
      opacity: 1
    },
    cx: 0,
    cy: 0,
    r: 40
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 -80 32)",
    id: "bicycle"
  }, /*#__PURE__*/React.createElement("circle", {
    style: {
      stroke: "rgb(234,111,28)",
      strokeWidth: 8,
      strokeDasharray: "none",
      strokeLinecap: "round",
      strokeDashoffset: 0,
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      fill: "none",
      fillRule: "nonzero",
      opacity: 1
    },
    cx: 0,
    cy: 0,
    r: 40
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 -38 -16)",
    id: "bicycle"
  }, /*#__PURE__*/React.createElement("polyline", {
    style: {
      stroke: "rgb(234,111,28)",
      strokeWidth: 8,
      strokeDasharray: "none",
      strokeLinecap: "round",
      strokeDashoffset: 0,
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      fill: "none",
      fillRule: "nonzero",
      opacity: 1
    },
    points: "-42,-48 -14,-48 42,48 "
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 -18.96 0)",
    id: "bicycle"
  }, /*#__PURE__*/React.createElement("polyline", {
    style: {
      stroke: "rgb(234,111,28)",
      strokeWidth: 8,
      strokeDasharray: "none",
      strokeLinecap: "round",
      strokeDashoffset: 0,
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      fill: "none",
      fillRule: "nonzero",
      opacity: 1
    },
    points: "61.04,-32 -14.38,-32 -61.04,32 "
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBike);
export default __webpack_public_path__ + "static/media/bike.35505d1595271364b8faac0b0a3b9814.svg";
export { ForwardRef as ReactComponent };